/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgNoteOnAzure
 */
export interface OrgNoteOnAzure {
    /**
     * 
     * @type {string}
     * @memberof OrgNoteOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteOnAzure
     */
    note: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteOnAzure
     */
    note_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteOnAzure
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof OrgNoteOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the OrgNoteOnAzure interface.
 */
export function instanceOfOrgNoteOnAzure(value: object): value is OrgNoteOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('note_name' in value) || value['note_name'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function OrgNoteOnAzureFromJSON(json: any): OrgNoteOnAzure {
    return OrgNoteOnAzureFromJSONTyped(json, false);
}

export function OrgNoteOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgNoteOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'note': json['note'],
        'note_name': json['note_name'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function OrgNoteOnAzureToJSON(json: any): OrgNoteOnAzure {
    return OrgNoteOnAzureToJSONTyped(json, false);
}

export function OrgNoteOnAzureToJSONTyped(value?: OrgNoteOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'note': value['note'],
        'note_name': value['note_name'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

